import { render, staticRenderFns } from "./SPRPrevNextButtons.vue?vue&type=template&id=170f9a74"
import script from "./SPRPrevNextButtons.vue?vue&type=script&lang=ts"
export * from "./SPRPrevNextButtons.vue?vue&type=script&lang=ts"
import style0 from "./SPRPrevNextButtons.vue?vue&type=style&index=0&id=170f9a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports